const baseUrl = '/account';
const baseUrlTeammember = '/teammember';
export const accountRoutes = {
  baseUrl: "".concat(baseUrl),
  confirm: "".concat(baseUrl, "/confirm"),
  sendConfirmation: "".concat(baseUrl, "/confirmation/send"),
  mfa: "".concat(baseUrl, "/mfa"),
  mfaTotpAssociate: "".concat(baseUrl, "/mfa/totp/associate"),
  mfaTotpVerify: "".concat(baseUrl, "/mfa/totp/verify"),
  phone: "".concat(baseUrl, "/phone"),
  confirmPhone: "".concat(baseUrl, "/phone/confirm"),
  mfaLogin: "".concat(baseUrl, "/login/mfa"),
  mfaSetupAssociate: "".concat(baseUrl, "/login/mfa-setup/associate"),
  mfaSetupVerify: "".concat(baseUrl, "/login/mfa-setup/verify"),
  login: "".concat(baseUrl, "/login"),
  loginPM: "".concat(baseUrl, "/login-pm"),
  loginInvite: "".concat(baseUrl, "/login-invite"),
  acceptInvite: "".concat(baseUrl, "/invite/accept"),
  changeTemporaryPassword: "".concat(baseUrl, "/temp-password"),
  refreshToken: "".concat(baseUrl, "/token/refresh"),
  forgotPassword: "".concat(baseUrl, "/password/forgot"),
  resetPassword: "".concat(baseUrl, "/password/reset"),
  logout: "".concat(baseUrl, "/logout"),
  logoutToken: "".concat(baseUrl, "/logoutRefreshToken"),
  password: "".concat(baseUrl, "/password"),
  invite: "".concat(baseUrl, "/invite"),
  invitev2: "".concat(baseUrl, "/invite-v2"),
  reInvite: accountId => "".concat(baseUrl, "/invite/").concat(accountId),
  profiles: "".concat(baseUrl, "/profiles"),
  enroll: "".concat(baseUrl, "/enroll"),
  updateProfileByAccountId: accountId => "".concat(baseUrl, "/").concat(accountId, "/profile"),
  updatePhoneByAccountId: accountId => "".concat(baseUrl, "/").concat(accountId, "/phone"),
  updateEmailByAccountId: accountId => "".concat(baseUrl, "/").concat(accountId, "/email"),
  featureFlags: "featureflags",
  updateUsersPortalAccessDate: accountId => "".concat(baseUrl, "/").concat(accountId, "/portal-access-date"),
  demoMode: "".concat(baseUrl, "/demo-mode"),
  teamMemberAccess: "".concat(baseUrlTeammember, "/access"),
  assignResourceTeamMember: "".concat(baseUrlTeammember, "/assign-resource"),
  subAccounts: "".concat(baseUrl, "/sub-accounts"),
  switchSubAccount: "".concat(baseUrl, "/switch-sub-account"),
  emailValidation: "/emailvalidation"
};